import { Typography } from "@material-ui/core"
import styled from "styled-components"

type StyledTitleProps = {
  $padding?: string
  $mobilePadding?: string
  $margin?: string
  $mobileMargin?: string
}

const StyledTitle = styled(Typography).attrs({
  component: "h1",
  variant: "h2",
})<StyledTitleProps>`
  color: #000;
  text-align: right;
  font-family: NarkisBlock;
  font-size: 40px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  max-width: 500px;

  ${(p) => p?.$padding && `padding: ${p.$padding};`}
  ${(p) => p?.$margin && `margin: ${p.$margin};`}

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    ${(p) => p?.$mobilePadding && `padding: ${p.$mobilePadding};`}
    ${(p) => p?.$mobileMargin && `margin: ${p.$mobileMargin};`}
  }
`

type PageTitleProps = {
  titleText: string
  ref?: any
  margin?: string
  mobileMargin?: string
  padding?: string
  mobilePadding?: string
}

const PageTitle = ({ ref, titleText }: PageTitleProps) => {
  return <StyledTitle ref={ref}>{titleText}</StyledTitle>
}

export default PageTitle
